import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
const mixin = {
  mixins: [validationMixin],
  validations: {
    actor_name: { required },
    linesJp: {
      value: {
        required,
      },
    },
  },
  computed: {
    actorNameErrors() {
      const errors = [];
      if (!this.$v.actor_name.$dirty) return errors;
      !this.$v.actor_name.required && errors.push("人物名を入力してください。");
      return errors;
    },
    linesJpErrors() {
      const errors = [];
      if (!this.$v.linesJp.value.$dirty) return errors;
      !this.$v.linesJp.value.required && errors.push("セリフの日本語を入力してください。");
      return errors;
    },
  },
};

export default mixin;
